import React from 'react';
import '../App.css';
import ScreenshotCarousel from '../components/ScreenshotCarousel';

export default function TomeMobile() {
  return (
    <div className="App">
      <header className="hero">
        <h1 className="hero-title">Tome – Your On-Device AI Chat Companion</h1>
        <p className="hero-subtitle">
          A 100% offline, private, and secure Android chatbot that runs a powerful
          large language model directly on your device.
        </p>
      </header>

      <section className="services">
        <h2>Overview</h2>
        <div className="service-cards">
          <div className="card">
            <h3>Built for Privacy</h3>
            <p>
              Tome keeps every conversation on your device. No cloud uploads,
              no external storage – just fast, local AI assistance.
            </p>
          </div>
          <div className="card">
            <h3>Hackathon Project</h3>
            <p>
              Originally built as a hackathon project to showcase what modern
              on-device AI can do on consumer Android hardware.
            </p>
          </div>
        </div>
      </section>

      <section className="services">
        <h2>Demo & Media</h2>
        <div className="service-cards">
          <div className="card">
            <h3>Product Demo Video</h3>
            <p>
              App Demo from 2025 Quackhacks Hackathon where Tome began.
            </p>
            <div style={{ marginTop: '1rem', maxWidth: '360px', marginLeft: 'auto', marginRight: 'auto' }}>
              <div style={{ position: 'relative', paddingBottom: '214.4444%', height: 0, overflow: 'hidden' }}>
                <iframe
                  title="Tome Demo Video"
                  src="https://www.youtube.com/embed/XQPeKVNmJl0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                />
              </div>
            </div>
          </div>
          <div className="card">
            <h3>Screenshots</h3>
            <ScreenshotCarousel
              images={[
                '/TomeScreenshots/SS1.jpg',
                '/TomeScreenshots/SS2.jpg',
                '/TomeScreenshots/SS3.jpg',
                '/TomeScreenshots/SS4.jpg',
                '/TomeScreenshots/SS5.jpg',
              ]}
            />
          </div>
        </div>
      </section>

      <section className="services">
        <h2>Key Features</h2>
        <div className="service-cards">
          <div className="card">
            <h3>Offline-First AI</h3>
            <p>
              Chat with an AI assistant anytime, anywhere – no internet
              required once your model is downloaded.
            </p>
          </div>
          <div className="card">
            <h3>Flexible Model Support</h3>
            <p>
              Download a recommended default model, or load your own compatible
              <code>.task</code> file directly from your device storage.
            </p>
          </div>
          <div className="card">
            <h3>Conversation Management</h3>
            <p>
              Create, switch between, and delete multiple chat sessions to
              organize different topics or workflows.
            </p>
          </div>
          <div className="card">
            <h3>Modern Android UI</h3>
            <p>
              A sleek interface built with Jetpack Compose, supporting light and
              dark themes and rendering AI responses in rich Markdown.
            </p>
          </div>
          <div className="card">
            <h3>Persistent History</h3>
            <p>
              Conversations and settings are stored locally so you can pick up
              where you left off.
            </p>
          </div>
        </div>
      </section>

      <section className="services">
        <h2>How It&apos;s Built</h2>
        <div className="service-cards">
          <div className="card">
            <h3>Tech Stack</h3>
            <p><strong>Language:</strong> 100% Kotlin</p>
            <p><strong>UI:</strong> Jetpack Compose</p>
            <p><strong>On-Device AI:</strong> Google MediaPipe LlmInference task</p>
            <p><strong>Concurrency:</strong> Kotlin Coroutines</p>
            <p><strong>Persistence:</strong> SharedPreferences + DataRepository pattern</p>
            <p><strong>Serialization:</strong> Gson for JSON conversations</p>
          </div>
          <div className="card">
            <h3>Getting Started</h3>
            <ol style={{ textAlign: 'left', paddingLeft: '1.25rem' }}>
              <li>Clone the repository in your Git client.</li>
              <li>Open the project in the latest Android Studio.</li>
              <li>Build &amp; run on an emulator or physical Android device.</li>
              <li>
                On first launch, open Settings in the app and download the
                default model to start chatting.
              </li>
            </ol>
          </div>
        </div>
      </section>

      <footer className="footer">
        <p>© 2025 RUNIC Solutions — Tome: AI that stays on your device.</p>
      </footer>
    </div>
  );
}
